/* Loretana — Hoop system builder (sitemap track)
   2026-09-25 first version: bag of hoop pairs + charm quantities.
   2026-10-10 v3 (owner «start the theme files» after the 10-tester round, report 02_WEBSITE/previews/earrings-10-testers-report-2026-10-10.html):
   · one pair at a time: hoop → charm → summary, «Build another pair» keeps a list (bridal / several gifts)
   · charm mode Both ears (×2) / One ear (×1) / Mix left & right — the price is never doubled silently
   · preview = a real photo of the charm on a hoop: the chosen hoop when its product has an image named «…-with-<charm>.…»,
     otherwise the reference set in the section setting «Reference photos» with a caption that says so
   · sold-out hoops collapse into one «Back soon» line
   · phone: sticky bar «Review & add» scrolls to the summary (policy is read before adding); it hides while the summary is on screen
   Data and words come from the section's JSON blocks ([data-hb-data], [data-hb-i18n]); prices in the store format (18,99 €).
   2026-11-02 (owner «yes», Mix & Match step 1): a charm product is a PAIR since 21/10, so one charm = quantity 1 (it put 2 pairs, 59,98 €, in the cart);
   the One ear / Mix modes are gone (owner 21/10: hoops and charms are always sold in pairs, one charm for each hoop).
   2026-11-03 (Mix & Match step 2, design 27/10): a chosen charm pops up big, then on the hoop (window.LxZoom from loretana-sitemap-mm.js); the preview opens big on tap. */
(function () {
  function money(n) { return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' €'; }
  function fmt(s, o) { return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(root) {
    var D, I = {}, REF = {};
    try { D = JSON.parse(root.querySelector('[data-hb-data]').textContent); } catch (e) { return; }
    try { I = JSON.parse(root.querySelector('[data-hb-i18n]').textContent); } catch (e) {}
    try { REF = JSON.parse(root.querySelector('[data-hb-ref]').textContent) || {}; } catch (e) {}
    var H = (D.hoops || []).filter(function (h) { return h && h.t; }), C = (D.charms || []).filter(function (c) { return c && c.t; }), live = !!D.live;
    var HA = H.filter(function (h) { return h.a !== false; }), HS = H.filter(function (h) { return h.a === false; });
    if (!HA.length) return;
    var free = parseFloat(root.getAttribute('data-free')) || 50;
    var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var S = { h: HA[0], mode: 'both', ear: 'L', L: null, R: null }, BAG = [];
    var q = function (s) { return root.querySelector(s); };

    // a deep link from the menu / Earrings page: ?hoop=<handle>&charm=<key>
    try {
      var P = new URLSearchParams(location.search);
      HA.forEach(function (h) { if (h.h === P.get('hoop')) S.h = h; });
      C.forEach(function (c) { if (c.k === P.get('charm')) { S.L = S.R = c; } });
    } catch (e) {}

    function shot(c) {
      if (!c) return { src: S.h.img, exact: true };
      if (S.h.x && S.h.x[c.k]) return { src: S.h.x[c.k], exact: true };
      if (REF[c.k]) return { src: REF[c.k], exact: false };
      return { src: c.img, exact: false };
    }
    function lines() {
      var L = [[S.h.t + ' · ' + I.pair, S.h.p]];
      if (S.L) L.push([S.L.t + ' · ' + I.pair, S.L.p]);
      return L;
    }
    function items() {
      var it = [{ id: S.h.v, quantity: 1 }];
      if (S.L) it.push({ id: S.L.v, quantity: 1 });
      return it;
    }
    var sum = function (L) { return L.reduce(function (s, l) { return s + l[1]; }, 0); };

    function draw() {
      // step 1 — hoops in stock; sold-out ones as one line
      q('[data-hb-hoops]').innerHTML = HA.map(function (h, i) {
        return '<button type="button" class="lx-hb__hc" data-hb-h="' + i + '" aria-pressed="' + (S.h === h) + '"><img src="' + esc(h.img) + '" alt="" loading="lazy"><b>' + esc(h.t) + '</b><span>' + money(h.p) + ' · ' + esc(I.pair) + '</span></button>';
      }).join('');
      q('[data-hb-soon]').innerHTML = HS.length ? '<span>' + esc(I.back_soon) + ' ' + HS.map(function (h) { return esc(h.t); }).join(' · ') + '</span>' : '';
      q('[data-hb-soon]').hidden = !HS.length;
      // step 2 — charms
      q('[data-hb-charms]').innerHTML = [null].concat(C).map(function (c, i) {
        var sel = S.L === c, tag = c ? '×2' : '';
        return '<button type="button" class="lx-hb__cc" data-hb-c="' + (i - 1) + '" aria-pressed="' + sel + '">' + (sel && tag ? '<span class="lx-hb__tag">' + tag + '</span>' : '') +
          (c ? '<img src="' + esc(c.img) + '" alt="" loading="lazy"><b>' + esc(c.t) + '</b><span>' + money(c.p) + '</span>' : '<span class="lx-hb__ph">' + esc(I.hoops_only) + '</span><b>' + esc(I.no_charm) + '</b><span>—</span>') + '</button>';
      }).join('');
      // preview
      var a = shot(S.L), pv = q('[data-hb-pv]');
      pv.className = 'lx-hb__pv';
      pv.innerHTML = '<img src="' + esc(a.src) + '" alt="' + esc(S.h.t + (S.L ? ' + ' + S.L.t : '')) + '" data-lx-zoom="' + esc(a.src + '|' + S.h.t + (S.L ? ' + ' + S.L.t : '')) + '">';
      q('[data-hb-cap]').textContent = !a.exact ? fmt(I.cap_ref, { h: S.h.t }) : (S.L ? fmt(I.cap_exact, { h: S.h.t }) : fmt(I.cap_none, { h: S.h.t }));
      // summary
      var L = lines(), tot = sum(L), bagTot = BAG.reduce(function (s, p) { return s + p.tot; }, 0), all = bagTot + tot;
      q('[data-hb-lines]').innerHTML = L.map(function (l) { return '<div class="lx-hb__r"><span>' + esc(l[0]) + '</span><span>' + money(l[1]) + '</span></div>'; }).join('');
      q('[data-hb-tot]').textContent = money(tot);
      var ok = all >= free;
      q('[data-hb-ship]').innerHTML = '<div class="lx-hs__ship"><i style="width:' + Math.min(100, all / free * 100) + '%"></i></div><p class="lx-hs__shipt' + (ok ? ' is-ok' : '') + '">' + esc(ok ? I.free_ok : fmt(I.free_add, { x: money(free - all) })) + '</p>';
      var btn = q('[data-hb-add]');
      btn.disabled = !live; btn.textContent = live ? fmt(I.add_pair, { x: money(tot) }) : I.preview_btn;
      q('[data-hb-stot]').textContent = money(tot);
      q('[data-hb-sdesc]').textContent = L.map(function (l) { return l[0].split(' · ')[0]; }).join(' + ');
      var bg = q('[data-hb-bag]'); bg.hidden = !BAG.length;
      q('[data-hb-baglines]').innerHTML = BAG.map(function (p, i) { return '<div class="lx-hb__r"><span>' + esc(fmt(I.pair_n, { n: i + 1 })) + ': ' + esc(p.d) + '</span><span>' + money(p.tot) + '</span></div>'; }).join('');
      q('[data-hb-bagtot]').textContent = money(bagTot);
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-hb-h],[data-hb-c],[data-hb-add],[data-hb-review],[data-hb-another]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-hb-h')) { S.h = HA[+t.getAttribute('data-hb-h')]; draw(); return; }
      if (t.hasAttribute('data-hb-c')) {
        var i = +t.getAttribute('data-hb-c');
        S.L = S.R = i < 0 ? null : C[i];
        draw();
        var zoom = S.L && window.LxZoom;
        if (window.innerWidth < 990) { var pv = q('[data-hb-pv]'); if (pv.getBoundingClientRect().top < 0) pv.scrollIntoView({ behavior: zoom ? 'auto' : 'smooth', block: 'center' }); }
        // 03/11 (design 27/10): the chosen charm pops up big, then on the hoop
        if (zoom) { var a = shot(S.L); LxZoom.open([[S.L.img, S.L.t], [a.src, !a.exact ? fmt(I.cap_ref, { h: S.h.t }) : fmt(I.cap_exact, { h: S.h.t })]], q('[data-hb-c="' + i + '"]')); }
        return;
      }
      if (t.hasAttribute('data-hb-review')) { q('[data-hb-sum]').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (t.hasAttribute('data-hb-another')) { S.L = S.R = null; draw(); q('[data-hb-top]').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (t.hasAttribute('data-hb-add')) {
        if (!live) return;
        var L = lines(), it = items();
        t.disabled = true; t.textContent = I.adding;
        fetch(root_url + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: it }) })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () {
            BAG.push({ d: L.map(function (l) { return l[0].split(' · ')[0]; }).join(' + '), tot: sum(L) });
            draw();
            var m = q('[data-hb-msg]'); m.hidden = false;
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(function () { t.disabled = false; t.textContent = I.add_err; });
      }
    });

    // phone: hide the sticky bar while the summary itself is visible
    var bar = q('[data-hb-sticky]');
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { bar.classList.toggle('is-hidden', en.isIntersecting); }); }, { threshold: 0.2 }).observe(q('[data-hb-sum]'));
      new IntersectionObserver(function (es) { es.forEach(function (en) { bar.classList.toggle('is-away', !en.isIntersecting); }); }, { threshold: 0 }).observe(q('[data-hb-top]'));
    }
    draw();
  }
  function boot() { document.querySelectorAll('[data-hb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
